import React from 'react'
import { Select } from '@mantine/core'

import { useAdminCalendarSilo } from './useAdminCalendarSilo'

import { ReporterSilo } from '@/apiClient'

export const AdminCalendarSiloSelect: React.FC = () => {
  const { silo, setSilo } = useAdminCalendarSilo()

  return (
    <Select
      variant="unstyled"
      className="w-24"
      data={[
        { value: ReporterSilo.digital_reporter, label: 'DR view' },
        { value: ReporterSilo.court_reporter, label: 'CR view' },
      ]}
      value={silo}
      onChange={value => value && setSilo(value as ReporterSilo)}
    />
  )
}
